import ApiServiceWrapper from './../../api-request.service';

const endpointPrefix =  'order/';
const ordersAPI = {
  getOrderHistory(qParams: string = '') {
    const reqEndPoint = `${endpointPrefix}get-order-history${qParams}`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  getOrderDetails(orderNo: string) {
    const reqEndPoint = `${endpointPrefix}get-order-detail?orderid=${orderNo}`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  deleteAutoRenawal(autoRenewalId: any) {
    const reqEndPoint = `${endpointPrefix}delete-auto-renewals`;
    return ApiServiceWrapper.delete(`${reqEndPoint}`, autoRenewalId);
  },
  voidOrder(request: any) {
    const reqEndPoint = 'sandbox/void-order';
    return ApiServiceWrapper.post(`${reqEndPoint}`, request);
  },
  emailOrderConfirmation(request: any) {
    const reqEndPoint = 'sandbox/resend-order-confirmation';
    return ApiServiceWrapper.post(`${reqEndPoint}`, request);
  },
};

export default ordersAPI;
